export const nameRegExp = /^([0-9a-z\u4E00-\u9FA5]){2,5}$/i
export const phoneRegExp = /^1\d{10}$/
export const passwordRegExp = /^([0-9A-Za-z]){6,16}$/i
export const consigneeNameRegExp = /^([0-9a-z\u4E00-\u9FA5]){2,10}$/i
